export default __webpack_public_path__ + "static/media/Principal.05e480ca.jpg";